<template>
  <v-btn-toggle class="no-box-shadow no-background" active-class="no-box-shadow no-background">
    <v-menu bottom left offset-x transition="slide-x-transition" close-on-click close-on-content-click>
      <template v-slot:activator="{ on }">
        <v-btn v-on="on" title="Baixar Documento" class="button-icon-button-group no-background"
               :key="'botaoBaixar' + documento.id" flat depressed active-class="no-background">
          <v-icon size="18px">mdi-download</v-icon>
        </v-btn>
      </template>

      <v-list class="lista-menu">
        <v-list-tile
            v-for="(item, index) in opcoesDownloadAtivas"
            :key="index"
            :value="item"
            @click.stop="$emit('baixarDocumentos', item.valor)">
            {{ item.label }}
        </v-list-tile>
      </v-list>
    </v-menu>
  </v-btn-toggle>
</template>

<script>
import {opcoesDownload} from '@/core/constants'

export default {
    name: 'BotaoDownload',
    props: ['documento'],
    computed: {
        opcoesDownloadAtivas(){
            if(!this.documento.assinado)
                return opcoesDownload.tiposDownload.filter(tipo => tipo.valor !== 'ASSINADO')
            else
                return opcoesDownload.tiposDownload
        }
    }
}
</script>

<style scoped lang="stylus">
.button-icon-button-group
    color rgb(119, 119, 119) !important
    background-color transparent !important

.no-box-shadow
    box-shadow none !important
    --webkit-box-shadow none !important
    --moz-box-shadow none !important

.no-background
    background-color transparent !important

.v-btn
    opacity 7 !important
</style>
